import React, { useContext, forwardRef } from 'react'
import PropTypes from 'prop-types'

import AccordionContext from '../Accordion/AccordionContext'
import Collapse from '../Collapse'

const AccordionPannel = forwardRef(function AccordionPannel(props, ref) {
	const { component: Component = 'div', children, className, TransitionProps, ...other } = props

	const { defaultExpanded, expanded } = useContext(AccordionContext)

	return (
		<Collapse in={expanded} appear={defaultExpanded} timeout="auto" {...TransitionProps}>
			<Component className={className} aria-expanded={expanded} ref={ref} {...other}>
				{children}
			</Component>
		</Collapse>
	)
})

export default AccordionPannel

AccordionPannel.defaultProps = {
	component: 'div'
}

AccordionPannel.propTypes = {
	/**
	 * The content of the component.
	 */
	children: PropTypes.node,
	/**
	 * @ignore
	 */
	className: PropTypes.string,
	/**
	 * The component used for the root node.
	 * Either a string to use a HTML element or a component.
	 * @default 'div'
	 */
	component: PropTypes.oneOfType([PropTypes.instanceOf(Element), PropTypes.node]),
	/**
	 * Props applied to the Collapse comopnen, build on top of [`Transition`].
	 * (http://reactcommunity.org/react-transition-group/transition).
	 */
	TransitionProps: PropTypes.object,
	/**
	 * If true, only the arrow symbols will be clickable and interactive.
	 * If false, all the Accordion Header will.
	 * Setting it true bypasses prop `showArrow` false state.
	 */
	onlyArrowExpand: PropTypes.bool,
	/**
	 * @ignore
	 */
	onClick: PropTypes.func
}
